import { post } from './http';
export const add = async ({ articleNumber, quantity = 1, isQuotationProduct, returnUpdatedCart = true, additionalInfo = null }) => {
    if (!quantity || isNaN(quantity) || parseFloat(quantity) <= 0) {
        throw 'Invalid quantity';
    }
    const response = await post('/api/nmas/cart/add', {
        articleNumber,
        quantity: parseFloat(quantity),
        isQuotationProduct,
        returnUpdatedCart,
        additionalInfo
    });
    return response.json();
};
export const addAdditionalInfo = async (additionalInfo) => {
    if (!additionalInfo || typeof additionalInfo !== 'object') {
        throw 'Invalid additionalInfo';
    }
    const response = await post('/api/nmas/cart/addAdditionalInfo', {
        additionalInfo
    });
    return response.json();
};
/**
 * @param {object[]} articleNumbers
 * @returns {Promise<*>}
 */
export const reorder = async (articleNumbers) => {
    const response = await post('/api/nmas/cart/reorder', articleNumbers);
    return response.json();
};
